import { render, staticRenderFns } from "./start_grading_container.vue?vue&type=template&id=86765e1e&scoped=true&"
import script from "./start_grading_container.vue?vue&type=script&lang=js&"
export * from "./start_grading_container.vue?vue&type=script&lang=js&"
import style0 from "./start_grading_container.vue?vue&type=style&index=0&id=86765e1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86765e1e",
  null
  
)

export default component.exports